import module from 'viaticos/module.js'
import template from './template.html'
import * as moment from 'moment'

export class ViaticosViaticoComponent {
  data = {
    colaborador: {},
    informacion: {},
    operadora: {},
    solicitudes: {},
    viaje: {},
    resumen: {
      saldo: 0,
      anticipos: 0,
      comprobaciones: 0,
      devoluciones: 0,
      reembolsos: 0,
    },
  }
  eliminando = false
  incluirTitulo = false
  revisarEnviando = false
  seguimiento = null
  viaticoId
  onClose

  constructor ($q, $state, ViaticosViaticoService, ViaticosViaticoSolicitudesService) {
    this.$q = $q
    this.$state = $state
    this.ViaticosViaticoService = ViaticosViaticoService
    this.ViaticosViaticoSolicitudesService = ViaticosViaticoSolicitudesService
  }

  $onInit () {
    this.promise = this.$q
      .all([
        this.ViaticosViaticoService.get(this.viaticoId).then(({data}) => data),
        this.ViaticosViaticoSolicitudesService.get(this.viaticoId).then(({data}) => data),
      ])
      .then(([data, solicitudes]) => {
        this.data = {...data, solicitudes}
        this.solicitud_id = solicitudes.anticipos.length
          ? solicitudes.anticipos[0]?.solicitud_id
          : solicitudes.comprobaciones[0]?.solicitud_id
        this.tipoViatico = this.data.tipo_id === 2 ? 'Comprobación' : 'Anticipo'
        this.calcularRevisar(this.data.informacion.revisarFecha, this.data.informacion.revisarEnviado)
        this.totalizar()
        this.data.responsableMaquilar = !!this.data.responsableMaquilar
      })
  }

  calcularRevisar (revisarFecha, revisarEnviado = null) {
    this.revisarEnviar = !revisarFecha
    if (revisarEnviado) {
      this.revisarEnviar = moment().isAfter(moment(revisarFecha).add(4, 'hours'))
    }
    this.revisarEnviando = false
  }

  getColaborador (data) {
    this.data.colaborador = data.colaborador
  }

  salir () {
    this.$state.go('.^')
  }

  getSeguimiento (seguimiento) {
    this.seguimiento = seguimiento
  }

  actualizar (key, data) {
    if (!key || !data) return

    this.data.solicitudes[key] = data
    this.data.solicitudes = {...this.data.solicitudes, [key]: [...data]}
    this.solicitudes = this.data.solicitudes
    this.totalizar()
  }

  eliminar (data) {
    this.eliminando = false
    if (!data.eliminado) return

    if (this.incluirTitulo) {
      this.$state.go('viaticos.pendientes.misviaticos')
    } else {
      this.onClose({$event: {detail: data}})
    }
  }

  totalizar () {
    this.data.informacion.eliminable = Object.keys(this.data.solicitudes)
      .every((tipoSolicitud) => (this.data.solicitudes[tipoSolicitud].length
        ? this.data.solicitudes[tipoSolicitud].every((solicitud) => solicitud.eliminable &&
          solicitud.acceso_eliminar)
        : true))
    this.data.resumen.anticipos = this.data.solicitudes.anticipos.reduce((total, item) => total +
      (item.autorizado && item.pagado ? item.total : 0), 0)
    this.data.resumen.comprobaciones = this.data.solicitudes.comprobaciones.reduce((total, item) => total +
      (item.autorizado ? item.total : 0), 0)
    this.data.resumen.devoluciones = this.data.solicitudes.devoluciones.reduce((total, item) => total +
      (item.autorizado ? item.total : 0), 0)
    this.data.resumen.reembolsos = this.data.solicitudes.reembolsos.reduce((total, item) => total +
      (item.autorizado && item.pagado ? item.total : 0), 0)
    this.data.resumen.saldo = (this.data.resumen.comprobaciones +
      this.data.resumen.devoluciones) -
      (this.data.resumen.anticipos + this.data.resumen.reembolsos)
  }
}

module.component('viaticosViatico', {
  controller: ViaticosViaticoComponent,
  template,
  bindings: {
    viaticoId: '<',
    incluirTitulo: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/viatico/component.js